// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__5YL73","insightsList":"newBusinessInsightsMenu_insightsList__1oLVK","active":"newBusinessInsightsMenu_active__2KHJe"};